var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('h3',[_vm._v("Seja bem vindo "+_vm._s(_vm.usuario.nome)+"!")])])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/pages/site/interna/Administrativa.vue?vue&type=template&id=156e41c9&
// module id = null
// module chunks = 